import { ReactNode, createContext, useContext } from "react";
import { useFilterItem } from "./filter-item.hook";

const FilterItemContext = createContext(
  {} as ReturnType<typeof useFilterItem>
);
export function useFilterItemContext() {
  return useContext(FilterItemContext);
}

interface FilterItemProviderProps {
  children: ReactNode;
}
export function FilterItemProvider({
  children,
}: FilterItemProviderProps) {
  return (
    <FilterItemContext.Provider value={useFilterItem()}>
      {children}
    </FilterItemContext.Provider>
  );
}